// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
#candidateRow td {
    color: black;
}

.table th{
    cursor: pointer;
    /* white-space: nowrap; */
}
.table td,.table span{
    /* white-space: nowrap; */
}

.flex-container {
    display: flex;
    flex-direction: column;
    
}
.filter-td {
    vertical-align: top;
    padding-right: 50px;
}
.filter-title {
    /* color: #000000; */
    font-size: 50;
    font-weight: bold;
}
.experience-input {
    width: 50px;
    border-radius: 10px;
}

.city-input {
    width: 150px;
    height: 30px;
    border-radius: 10px;
}
.th-hover-on:hover{
    background-color: #c2f2c9;
}

.type-label {
    margin-left:5px;
    margin-right: 15px;
    color: #918f8e
}

.type-input {
    margin-left: 20px;
    padding-left: 20px;
}

.checkbox-container {
    background-color: #e8e8e8;
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
    border-radius: 10px;
    padding:2px
}

.filter_fold_container {
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
    border-radius: 20px;
    padding-left: 20px;
    width: 400px;
    margin-bottom: 15px;
}

.filter_container{
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
    background-color: #f5f5f5;
    padding-left: 20px;
    margin-bottom: 30px;
    border-radius: 20px;
    padding-bottom: 5px;
}

.center-search-container {
    width: 100%;
    margin-top: 12%;
    height: 400px;
    display: flex;
    justify-content: center;
     align-items: center; background-color: white;
    background-repeat: no-repeat;
    background-position: center;

}

.search-input {
    width: 600px;
    border-radius: 25px;
    height: 50px;
    border: 1px solid #fcefcc;
    box-shadow: rgba(80, 43, 8, 0.2) 0px 2px 8px 0px;
    margin-bottom: 50px;
    padding: 10px;
    padding-left: 15px;
    
}

.btn-search-mid {
    border-radius: 15px;
    background: #F2F2F2;
    box-shadow: rgba(0, 0, 0, 0.2) 0px 2px 4px;
}

.btn-search-mid:focus {
    outline: none;
}

.search-input:focus {
    box-shadow: rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.22) 0px 8px 16px -8px;
    border-radius: 20px;
    transition: 500ms;
    outline: none
}

.title-text {
    font-family: garamond; color: black; font-size:large; font-weight: 700;
}`, "",{"version":3,"sources":["webpack://./src/app/search/search.component.css"],"names":[],"mappings":";AACA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,sBAAsB;;AAE1B;AACA;IACI,mBAAmB;IACnB,mBAAmB;AACvB;AACA;IACI,oBAAoB;IACpB,aAAa;IACb,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,mBAAmB;AACvB;AACA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB;AACJ;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,iDAAiD;IACjD,mBAAmB;IACnB;AACJ;;AAEA;IACI,iDAAiD;IACjD,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,iDAAiD;IACjD,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,aAAa;IACb,aAAa;IACb,uBAAuB;KACtB,mBAAmB,EAAE,uBAAuB;IAC7C,4BAA4B;IAC5B,2BAA2B;;AAE/B;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,yBAAyB;IACzB,gDAAgD;IAChD,mBAAmB;IACnB,aAAa;IACb,kBAAkB;;AAEtB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,0CAA0C;AAC9C;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,4FAA4F;IAC5F,mBAAmB;IACnB,iBAAiB;IACjB;AACJ;;AAEA;IACI,qBAAqB,EAAE,YAAY,EAAE,eAAe,EAAE,gBAAgB;AAC1E","sourcesContent":["\n#candidateRow td {\n    color: black;\n}\n\n.table th{\n    cursor: pointer;\n    /* white-space: nowrap; */\n}\n.table td,.table span{\n    /* white-space: nowrap; */\n}\n\n.flex-container {\n    display: flex;\n    flex-direction: column;\n    \n}\n.filter-td {\n    vertical-align: top;\n    padding-right: 50px;\n}\n.filter-title {\n    /* color: #000000; */\n    font-size: 50;\n    font-weight: bold;\n}\n.experience-input {\n    width: 50px;\n    border-radius: 10px;\n}\n\n.city-input {\n    width: 150px;\n    height: 30px;\n    border-radius: 10px;\n}\n.th-hover-on:hover{\n    background-color: #c2f2c9;\n}\n\n.type-label {\n    margin-left:5px;\n    margin-right: 15px;\n    color: #918f8e\n}\n\n.type-input {\n    margin-left: 20px;\n    padding-left: 20px;\n}\n\n.checkbox-container {\n    background-color: #e8e8e8;\n    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;\n    border-radius: 10px;\n    padding:2px\n}\n\n.filter_fold_container {\n    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;\n    border-radius: 20px;\n    padding-left: 20px;\n    width: 400px;\n    margin-bottom: 15px;\n}\n\n.filter_container{\n    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;\n    background-color: #f5f5f5;\n    padding-left: 20px;\n    margin-bottom: 30px;\n    border-radius: 20px;\n    padding-bottom: 5px;\n}\n\n.center-search-container {\n    width: 100%;\n    margin-top: 12%;\n    height: 400px;\n    display: flex;\n    justify-content: center;\n     align-items: center; background-color: white;\n    background-repeat: no-repeat;\n    background-position: center;\n\n}\n\n.search-input {\n    width: 600px;\n    border-radius: 25px;\n    height: 50px;\n    border: 1px solid #fcefcc;\n    box-shadow: rgba(80, 43, 8, 0.2) 0px 2px 8px 0px;\n    margin-bottom: 50px;\n    padding: 10px;\n    padding-left: 15px;\n    \n}\n\n.btn-search-mid {\n    border-radius: 15px;\n    background: #F2F2F2;\n    box-shadow: rgba(0, 0, 0, 0.2) 0px 2px 4px;\n}\n\n.btn-search-mid:focus {\n    outline: none;\n}\n\n.search-input:focus {\n    box-shadow: rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.22) 0px 8px 16px -8px;\n    border-radius: 20px;\n    transition: 500ms;\n    outline: none\n}\n\n.title-text {\n    font-family: garamond; color: black; font-size:large; font-weight: 700;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
